import { MutableRefObject } from 'react';

import { NuveiSDK } from '../components/Checkout/components/NuveiPayment/types';
import {
  EventParams,
  MixpanelEvents,
  Offer,
  PaymentMethod,
  SubscriptionsSummary,
} from '../contracts';
import { sendMixpanelEvent } from '../utils/mixpanel-utils';

export interface ICheckoutSummaryContext {
  checkoutData?: Offer;
  subscriptionData?: SubscriptionsSummaryContext;
  isCheckoutDataLoading: boolean;
  getEventParams: () => EventParams;
  enrichEventParams: () => EventParams;
  selectedPaymentMethod?: PaymentMethod;
  onPaymentMethodChange: (pm: PaymentMethod) => void;
  safeCharge: NuveiSDK;
  selectedPaymentMethodDisplayNameRef: MutableRefObject<string>;
  redirectUrl?: string;
  disableRedirect?: boolean;
}

export interface SubscriptionsSummaryContext {
  plan?: SubscriptionsSummary['plan'];
  paymentIntent?: SubscriptionsSummary['paymentIntent'];
  pricing?: SubscriptionsSummary['pricing'];
  firstPaymentDiscount?: SubscriptionsSummary['firstPaymentDiscount'];
}

const CHECKOUT_OPENED_AT_KEY = 'checkout_opened_at';

const getCheckoutLoadTime = (): number | undefined => {
  const checkoutOpenedAt = Number(sessionStorage.getItem(CHECKOUT_OPENED_AT_KEY));

  if (!Number.isFinite(checkoutOpenedAt)) {
    return undefined;
  }

  return Math.max(0, Math.round(performance.now() - checkoutOpenedAt));
};

export const trackCheckoutPresented = (eventParams: EventParams): void => {
  sendMixpanelEvent(MixpanelEvents.CHECKOUT_PRESENTED, {
    ...eventParams,
    load_time: getCheckoutLoadTime(),
  });
};

export const trackCheckoutOpened = (eventParams: EventParams): void => {
  sessionStorage.setItem(CHECKOUT_OPENED_AT_KEY, performance.now().toString());
  sendMixpanelEvent(MixpanelEvents.CHECKOUT_OPENED, {
    ...eventParams,
  });
};
